import { TAIWAN_CALLING_CODE } from '@/constants/regions'

/**
 * 根據當前地區取得預設電話國碼
 */
export function useDefaultPhoneRegion() {
  // spec 目前是寫死給台灣 +886, 原本有實作根據 regionId 回傳對應國碼的邏輯，但因為目前沒有使用需求，先註解說明
  const getDefaultPhonePrefix = (): string => {
    return TAIWAN_CALLING_CODE
  }

  return {
    getDefaultPhonePrefix,
  }
}
